import React, { useEffect } from "react";
import { Area } from "../../models/Area";
import { Equipment } from "../../models/Equipment";
import MapObjectAttachmentsSlider from "../Map/MapObjectAttachments/MapObjectAttachmentsSlider";
import MapObjectIframeViewer from "../Map/MapObjectAttachments/MapObjectIframeViewer";

interface DamnMappableAttachmentsProps {
    mappable: Area | Equipment | null;
}

const DamnMappableAttachments: React.FC<DamnMappableAttachmentsProps> = ({ mappable }) => {
    const [iframe, setIframe] = React.useState<string | null>(null);

    useEffect(() => {
        if (!mappable) {
            setIframe(null);
            return;
        }

        if (mappable instanceof Area) {
            setIframe(mappable.attachmentMethod === "iframe" && mappable.areaIframe ? mappable.areaIframe : null);
        } else if (mappable instanceof Equipment) {
            setIframe(
                mappable.attachmentMethod === "iframe" && mappable.equipmentIframe ? mappable.equipmentIframe : null
            );
        }
    }, [mappable]);

    if (!mappable) return null;
    return (
        <div className="w-full h-auto max-h-48 xl:w-48 xl:h-auto xl:max-h-full shrink-0 overflow-hidden rounded-lg flex items-center justify-center">
            {iframe ? (
                <MapObjectIframeViewer iframe={iframe} />
            ) : (
                <MapObjectAttachmentsSlider currentObject={mappable} />
            )}
        </div>
    );
};

export default DamnMappableAttachments;
